// import axios from 'axios';
import {
    PatientDetailsServiceConst
} from '@/app/pharmacy/shared/services/patient-details-service';
import { visitService } from '@/app/pharmacy/shared/services/visit-service';
import { dispensedHistoryCommon } from '@/app/pharmacy/pharmacy-management/dispensed-history/dispensed-history-common';
import { getVisitClassificationEnum, getOrderLineStatusEnum, getFilterationTabsEnum, getCreatedByModuleForMedicationEnum, getMedicationCreationNeedIdEnum} from '@/app/pharmacy/shared/pharmacy-enums.js'

import { AppStorage } from '@/app/shared/services/app-storage/app-storage.js';
import { EventBus } from '@/app/shared/services/event-bus.js';
import { getPharamcyAttachmentEnum } from '@/app/shared/shared-enums.js';

let storage = new AppStorage();

const state = {
    isIvGoToDispenseHistory: false,
    returnByRecieptClicked:false,
    loadingAdvanced:false,
    loadingPhysOrderGrid:false,
    activeTabFilteration: 2,
    prescriptionTypeRadio: 1,
    DispenseTypeRadio: 3,
    SelectedItems: [],
    VisitNoteDS: [],
    SelectedItemsForPhysOrder: [],
    EditInsuranceDetailsParameters: {},
    DoneServicesIdsForcompleteStep: [],
    IsIV: false,
    IsIVOwnMedicationCheargeAllowed: false,
    LoadIVOrders:false,
    // start filtration of phy-order Tab 
    formFiltered_phyOrder: {
        visitClassification: "",
        searchByNameID: "",
        currentVisit: true
    },
    userList_phyOrder: [],
    userListFiltered_phyOrder: [],
    // End filtration of phy-order Tab 


    // start filtration of Dis-History Tab 
    formFiltered_DisHistory: {
        visitClassification: "",
        searchByNameID: "",
        searchStartDate: "",
        searchEndDate: "",
        currentVisit: true
    },
    userList_DisHistory: [
        {
            user_id: 1,
            ProcedureUserName: 'George Youssef Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'inprogress',
            visitClassification: "1",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 2,
            ProcedureUserName: 'Aya Namour Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'finished',
            visitClassification: "2",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: false,
                minusCircle: true,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 3,
            ProcedureUserName: 'Aya Amer Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'discharged',
            visitClassification: "3",
            currentVisit: true,
            multiIcons: {
                checked: false,
                plusCircle: false,
                minusCircle: true,
                money: true,
                blueGender: true
            },
        },
        {
            user_id: 4,
            ProcedureUserName: 'Aya UDI Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'arrived',
            visitClassification: "4",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: false,
                blueGender: true
            },

        },
        {
            user_id: 5,
            ProcedureUserName: 'Alaa Mahdy Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'planned',
            visitClassification: "1",
            currentVisit: false,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 6,
            ProcedureUserName: 'Noha Essam Dis-History',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'inprogress',
            visitClassification: "2",
            currentVisit: false,
            multiIcons: {
                checked: true,
                plusCircle: false,
                minusCircle: true,
                money: false,
                blueGender: true
            },
        },
    ],
    userListFiltered_DisHistory: null,
    // End filtration of Dis-History Tab 


    // start filtration of E-prescription Tab 
    formFiltered_Prescription: {
        visitClassification: "",
        searchByNameID: "",
        currentVisit: true
    },
    userList_Prescription: [
        {
            user_id: 1,
            ProcedureUserName: 'George Youssef E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'inprogress',
            visitClassification: "1",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 2,
            ProcedureUserName: 'Aya Namour E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'finished',
            visitClassification: "2",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: false,
                minusCircle: true,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 3,
            ProcedureUserName: 'Aya Amer E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'discharged',
            visitClassification: "3",
            currentVisit: true,
            multiIcons: {
                checked: false,
                plusCircle: false,
                minusCircle: true,
                money: true,
                blueGender: true
            },
        },
        {
            user_id: 4,
            ProcedureUserName: 'Aya UDI E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'arrived',
            visitClassification: "4",
            currentVisit: true,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: false,
                blueGender: true
            },

        },
        {
            user_id: 5,
            ProcedureUserName: 'Alaa Mahdy E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed3',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'planned',
            visitClassification: "1",
            currentVisit: false,
            multiIcons: {
                checked: true,
                plusCircle: true,
                minusCircle: false,
                money: true,
                blueGender: false
            },
        },
        {
            user_id: 6,
            ProcedureUserName: 'Noha Essam E-prescription',
            ProcedureRoomLocation: 123456,
            ProcedureRoomNumber: 'Room1',
            ProcedurededNumber: 'bed4',
            ProcedureDate: '29/06/1989 3:30 PM',
            statusVaue: 'inprogress',
            visitClassification: "2",
            currentVisit: false,
            multiIcons: {
                checked: true,
                plusCircle: false,
                minusCircle: true,
                money: false,
                blueGender: true
            },
        },
    ],
    userListFiltered_Prescription: [],
    // End filtration of E-prescription Tab 

    country_Status: null,
    // usersListDemo: []
    globalPatientListDs: [],
    gridPatientPhyOrder: {},
    gridPatientDisHistory: {
        CliniclaTransactionFilterationLookUps: {}
    },
    gridPatientEprescreption: null,
    gridPatientObj: {
        showPatientBanner: false,
        //  isLoading: false
    },
    isLoading: false,
    isLoadingReciept: false,
    isLoadingPhyOrder: false,
    advancedFilterCriteria: {},
    PhysOrderAdvancedFilterCriteria: {},
    advancedFilterResultsAddedItems: {},
    isVisitViewFirstLoad: false,
    selectedVisitClassificationForFilteration: null,
    selectedVisitClassificationForFilterationforPrescription: null,
    selectedVisitClassificationForFilterationforPhysicianOrders: null,
    isShowGridAdvancedFilter: false,
    isPhysOrderAdvncedFilterClicked: false,
    isFilterButtoneClicked: false,
    initVisitView: false,
    initTabsView: false,
    isCompeletedStep: false,
    showPrintPres: false,
    isByOrderMode: false,
    servicePaymentReceiptData: {
        showReceipt: false,
        receiptDtat: {}
    },
    isVisitSelected: false,
    closeConfirmOverridePopup: false,

    isCreditCashRefund: false,
    isClinicalServiceTabSelected: true,
    retrieveMedicationOLParameters: {
        VisitID: 0,
        DispensedTodate: null,
        ProductID: null,
        Orderlinefromdate: null,
        OrderlineTodate: null,
        PhysicianID: null,
        OrderlineStatus: null,
        IsHomeMedication: false,
        CreatedbyModule: null,
        AuthApprovalStatus: null,
        BillingApprovalStatus: null
    },
    goToDispensingHistoryTab: false,
    filterationCriteriaObject: {},
    currentVisitsList: [],
    medicationProductsAvailableQty: [],
    userId: 0,
};

// Get data
const getters = {
    isGoToDispenseHistory(state) {
    
        return state.isIvGoToDispenseHistory;

    },
    IsIVOwnMedicationCheargeAllowed(state) {
        return state.IsIVOwnMedicationCheargeAllowed;
    },
    returnByRecieptClicked(state) {
        return state.returnByRecieptClicked;
    },
    loadingPhysOrderGrid(state) {
        return state.loadingPhysOrderGrid;
    },
    loadingAdvanced(state) {
        return state.loadingAdvanced;
    },
    userId(state) {
        return state.userId;

    },
    retrieveMedicationOLParameters(state) {
        return state.retrieveMedicationOLParameters;

    }, medicationProductsAvailableQty(state) {
        return state.medicationProductsAvailableQty;

    },
    currentVisitsList(state) {
        return state.currentVisitsList;

    },
    goToDispensingHistoryTab(state) {
        return state.goToDispensingHistoryTab;

    },
    filterationCriteriaObject(state) {
        return state.filterationCriteriaObject;

    }, closeConfirmOverridePopup(state) {
        return state.closeConfirmOverridePopup;

    },
    save_VisitNoteDS(state) {
        return state.VisitNoteDS;

    },

    servicePaymentReceiptData(state) {
        return state.servicePaymentReceiptData;

    },

    EditInsuranceDetailsParameters(state) {
        return state.EditInsuranceDetailsParameters;

    },
    SelectedItems(state) {
        return state.SelectedItems;

    },

    SelectedItemsForPhysOrder(state) {
        return state.SelectedItemsForPhysOrder;

    },
    
    DoneServicesIdsForcompleteStep(state) {
        return state.DoneServicesIdsForcompleteStep;

    },
    activeTabFilteration(state) {
        return state.activeTabFilteration;

    },
    selectedVisitClassificationForFilteration(state) {
        console.log(state);
        return storage.getItem('SelectedVisitClassification');
    },

    selectedVisitClassificationForFilterationforPrescription(state) {
        console.log(state);
        return storage.getItem('selectedVisitClassificationForFilterationforPrescription');
    },
    selectedVisitClassificationForFilterationforPhysicianOrders(state) {
        console.log(state);
        return storage.getItem('selectedVisitClassificationForFilterationforPhysicianOrders');
    },
    initVisitView(state) {
        return state.initVisitView;
    },
    initTabsView(state) {
        return state.initTabsView;

    },
    isVisitViewFirstLoad(state) {
        return state.isVisitViewFirstLoad;
    },
    isShowGridAdvancedFilter(state) {
        return state.isShowGridAdvancedFilter;
    },
    isPhysOrderAdvncedFilterClicked(state) {
        return state.isPhysOrderAdvncedFilterClicked;

    },
    isFilterButtoneClicked: state => state.isFilterButtoneClicked,
    isVisitSelected: state => state.isVisitSelected,
    isCompeletedStep: state => state.isCompeletedStep,
    showPrintPres: state => state.showPrintPres,
    isByOrderMode: state => state.isByOrderMode,



    advancedFilterResultsAddedItems(state) {
        return state.advancedFilterResultsAddedItems;
    },
    advancedFilterCriteria(state) {
        return state.advancedFilterCriteria;
    },
    PhysOrderAdvancedFilterCriteria(state) {
        return state.PhysOrderAdvancedFilterCriteria;
    },

    tabFilteration(state) {
        return state.activeTabFilteration;
    },
    prescriptionTypeRadio(state) {
        return state.prescriptionTypeRadio;
    },
    DispenseTypeRadio(state) {
        return state.DispenseTypeRadio;
    },
    countryStatusList(state) {
        return state.country_Status;
    },

    // start filtration of phy-order Tab 
    formFiltered_phyOrder(state) {
        return state.formFiltered_phyOrder;
    },
    userList_phyOrder(state) {
        return state.userList_phyOrder;
    },
    userListFiltered_phyOrder(state) {
        return state.userListFiltered_phyOrder;
    },
    // End filtration of phy-order Tab 


    // start filtration of Dis-History Tab 
    formFiltered_DisHistory(state) {
        return state.formFiltered_DisHistory;
    },
    userList_DisHistory(state) {
        return state.userList_DisHistory;
    },
    userListFiltered_DisHistory(state) {
        return state.userListFiltered_DisHistory;
    },
    // End filtration of Dis-History Tab 


    // start filtration of E-prescription Tab 
    formFiltered_Prescription(state) {
        return state.formFiltered_Prescription;
    },
    userList_Prescription(state) {
        return state.userList_Prescription;
    },
    userListFiltered_Prescription(state) {
        return state.userListFiltered_Prescription;
    },
    // End filtration of E-prescription Tab 


    // usersListDemo(state) {
    //     return state.usersListDemo;
    // }

    globalPatientListDs(state) {
        return state.globalPatientListDs;
    },
    gridPatientPhyOrder(state) {
        return state.gridPatientPhyOrder;
    },
    gridPatientDisHistory(state) {
        return state.gridPatientDisHistory;
    },
    gridPatientObj(state) {

        return state.gridPatientObj;
    },
    gridPatientEprescreption(state) {

        return state.gridPatientEprescreption;
    },

    isLoading(state) {
        return state.isLoading;
    },
    isLoadingReciept(state) {
        return state.isLoadingReciept;
    },
    isLoadingPhyOrder: state => state.isLoadingPhyOrder,

    isCreditCashRefund(state) {
        return state.isCreditCashRefund;
    },
    // if true => Clinical Service Tab Selected if false => Payments and Receipts Tab Selected
    isClinicalServiceTabSelected(state) {
        return state.isClinicalServiceTabSelected;
    },
    IsIV(state) {
        return state.IsIV;
    },
    LoadIVOrders(state) {
        return state.LoadIVOrders;
    }
};


// Update Data "mutations"
const mutations = {
    save_returnByRecieptClicked(state, payload) {
        state.returnByRecieptClicked = payload;
    },
    save_loadingPhysOrderGrid(state, payload) {
        state.loadingPhysOrderGrid = payload;
    },
    save_loadingAdvanced(state, payload) {
        state.loadingAdvanced = payload;
    },
    Save_IsIV(state, payload) {
        state.IsIV = payload;
    },
    Save_IsIVOwnMedicationCheargeAllowed(state, payload) {
        state.IsIVOwnMedicationCheargeAllowed = payload;
    },
    Save_LoadIVOrders(state, payload) {
        state.LoadIVOrders = payload;
    },
    Save_userId(state, payload) {
        state.userId = payload;

    },
    Save_currentVisitsList(state, payload) {
        state.currentVisitsList = payload;

    },
    Save_goToDispensingHistoryTab(state, payload) {
        state.goToDispensingHistoryTab = payload;

    },
    Save_filterationCriteriaObject(state, payload) {
        state.filterationCriteriaObject = payload;

    },
    Save_retrieveMedicationOLParameters(state, payload) {
        state.retrieveMedicationOLParameters = payload;

    }, Save_medicationProductsAvailableQty(state, payload) {
        state.medicationProductsAvailableQty = payload;

    },
    save_VisitNoteDS(state, payload) {
        state.VisitNoteDS = payload;
    },
    Save_closeConfirmOverridePopup(state, payload) {
        state.closeConfirmOverridePopup = payload;
    },
    Save_EditInsuranceDetailsParameters(state, EditInsuranceDetailsParameters) {
        state.EditInsuranceDetailsParameters = EditInsuranceDetailsParameters;
    },
    Save_servicePaymentReceiptData(state, payload) {
        state.servicePaymentReceiptData = payload;
    },

    Save_SelectedItems(state, SelectedItems) {
        state.SelectedItems = SelectedItems;
    },

    Save_SelectedItemsForPhysOrder(state, SelectedItemsForPhysOrder) {
        state.SelectedItemsForPhysOrder = SelectedItemsForPhysOrder;

    },
    Save_DoneServicesIdsForcompleteStep(state, DoneServicesIdsForcompleteStep) {
        state.DoneServicesIdsForcompleteStep = DoneServicesIdsForcompleteStep;

    },
    

    Reset_SelectedItems(state) {
        state.SelectedItems = [];
    },


    Reset_globalPatientListDs(state) {
        state.globalPatientListDs = [];
    },

    selectedVisitClassificationForFilteration(state, payload) {
        storage.setItem('SelectedVisitClassification', payload);
    },

    selectedVisitClassificationForFilterationforPrescription(state, payload) {
        storage.setItem('selectedVisitClassificationForFilterationforPrescription', payload);
    },

    selectedVisitClassificationForFilterationforPhysicianOrders(state, payload) {
        storage.setItem('selectedVisitClassificationForFilterationforPhysicianOrders', payload);
    },

    isVisitViewFirstLoad(state, payload) {
        state.isVisitViewFirstLoad = payload;
    },
    initVisitView(state, payload) {
        state.initVisitView = payload;
    },

    initTabsView(state, payload) {
        state.initTabsView = payload;

    },

    isShowGridAdvancedFilter(state, flag) {
        state.isShowGridAdvancedFilter = flag;
    },

    isPhysOrderAdvncedFilterClicked(state, flag) {
        state.isPhysOrderAdvncedFilterClicked = flag;

    },

    isFilterButtoneClicked: (state, flag) => { state.isFilterButtoneClicked = flag },
    isVisitSelected: (state, flag) => { state.isVisitSelected = flag },
    isCompeletedStep: (state, flag) => { state.isCompeletedStep = flag },
    showPrintPres: (state, flag) => { state.showPrintPres = flag },
    isByOrderMode: (state, flag) => { state.isByOrderMode = flag },




    advancedFilterResultsAddedItems(state, payload) {
        state.advancedFilterResultsAddedItems = payload;
    },
    advancedFilterCriteria(state, payload) {
        state.advancedFilterCriteria = payload;
    },
    PhysOrderAdvancedFilterCriteria(state, payload) {
        state.PhysOrderAdvancedFilterCriteria = payload;
    },

    filterationActiveTab(state, payload) {
        state.activeTabFilteration = payload;

    },
    save_prescriptionTypeRadio(state, payload) {
        state.prescriptionTypeRadio = payload;
    },

    save_DispenseTypeRadio(state, payload) {
        state.DispenseTypeRadio = payload;
    },
    // SAVE_USERS(state, users) {
    //     state.usersListDemo = users;
    // },

    // start filtration of phy-order Tab 
    save_formFiltered_phyOrder(state, payload) {
        state.formFiltered_phyOrder = payload;
    },
    save_userListFiltered_phyOrder(state, payload) {
        state.userListFiltered_phyOrder = payload;
    },
    // End filtration of phy-order Tab 


    // start filtration of Dis-History Tab 
    save_formFiltered_DisHistory(state, payload) {
        state.formFiltered_DisHistory = payload;
    },
    save_userListFiltered_DisHistory(state, payload) {
        state.userListFiltered_DisHistory = payload;
    },
    // End filtration of Dis-History Tab 


    // start filtration of E-prescription Tab 
    save_formFiltered_Prescription(state, payload) {
        state.formFiltered_Prescription = payload;
    },
    save_userListFiltered_Prescription(state, payload) {
        state.userListFiltered_Prescription = payload;
    },
    // End filtration of E-prescription Tab 



    save_globalPatientListDs(state, payload) {
        state.globalPatientListDs = payload;
    },
    save_VisitDispenseHistory(state, payload) {
        state.gridPatientDisHistory = payload;
    },

    save_PhysOrderData(state, payload) {
        state.gridPatientPhyOrder = payload;
    },
    save_PatientInfo(state, payload) {
        state.gridPatientObj = payload;

    },
    save_showLoader(state, payload) {
        state.isLoading = payload;
    },
    save_showRecieptLoader(state, payload) {
        state.isLoadingReciept = payload;
    },
    loadingAdvanced(state, payload) {
        state.isLoading = payload;
    },
    save_showLoaderPhyPrder: (state, payload) => state.isLoadingPhyOrder = payload,

    Save_isCreditCashRefund(state, payload) {
        state.isCreditCashRefund = payload;
    },

    save_isClinicalServiceTabSelected(state, payload) {
        state.isClinicalServiceTabSelected = payload;
    },
    save_isReturnByrecieptSelected(state, payload) {
        state.isReturnByrecieptSelected = payload;
    },
    save_isIvGoToDispenseHistory(state, payload) {
        state.isIvGoToDispenseHistory = payload;
    },

};

const actions = {
    load_returnByRecieptClicked(context, payload) {
        context.commit('save_returnByRecieptClicked', payload);
    },
    load_loadingPhysOrderGrid(context, payload) {
        context.commit('save_loadingPhysOrderGrid', payload)
    },
    load_loadingAdvanced(context, payload) {
        context.commit('save_loadingAdvanced', payload);
    },
    load_howRecieptLoader(context, payload) {
        
        context.commit('save_showRecieptLoader', payload);
    },
    
    Save_userId(context, payload) {
        context.commit('Save_userId', payload);
    },
    Save_currentVisitsList(context, payload) {
        context.commit('Save_currentVisitsList', payload);
    },
    Save_PhysOrderData(context, payload) {
        context.commit('save_PhysOrderData', payload);
    },
    Save_goToDispensingHistoryTab(context, payload) {
        context.commit('Save_goToDispensingHistoryTab', payload.goToDispensingHistoryTab);
        context.commit('Save_filterationCriteriaObject', payload.filterationCriteriaObject);
        context.commit('save_globalPatientListDs', payload.visitListDataSource);
    },

    retrieve_MedicationOLByParameters(context, payload) {
        context.commit('Save_retrieveMedicationOLParameters', payload);
    },
    Save_medicationProductsAvailableQty(context, payload) {
        context.commit('Save_medicationProductsAvailableQty', payload);
    },
    save_VisitNoteDS(context, payload) {
        context.commit('save_VisitNoteDS', payload);

    },
    Save_closeConfirmOverridePopup(context, payload) {
        context.commit('Save_closeConfirmOverridePopup', payload);
    },
    Save_servicePaymentReceiptData({ commit }, payload) {
        commit('Save_servicePaymentReceiptData', payload);

    },

    clear_visitView(context) {
        context.commit('save_PatientInfo', { showPatientBanner: false });
    },

    Save_EditInsuranceDetailsParameters(context, payload) {

        context.commit('Save_EditInsuranceDetailsParameters', payload);
    },

    Save_SelectedItems(context, payload) {

        context.commit('Save_SelectedItems', payload);
    },

    Save_SelectedItemsForPhysOrder(context, payload) {

        context.commit('Save_SelectedItemsForPhysOrder', payload);
    },
    Save_DoneServicesIdsForcompleteStep(context, payload) {

        context.commit('Save_DoneServicesIdsForcompleteStep', payload);
    },

    

    filterationActiveTab(context, payload) {

        context.commit('filterationActiveTab', payload);
        context.commit('initTabsView', true);

    },

    Reset_SelectedItems(context, payload) {

        context.commit('Reset_SelectedItems', payload);
    },

    Reset_globalPatientListDs(context, payload) {

        context.commit('Reset_globalPatientListDs', payload);
    },
    save_selectedVisitClassificationForFilteration(context, payload) {
        context.commit('selectedVisitClassificationForFilteration', payload);
    },

    save_selectedVisitClassificationForFilterationforPrescription(context, payload) {
        context.commit('selectedVisitClassificationForFilterationforPrescription', payload);
    },
    save_selectedVisitClassificationForFilterationforPhysicianOrders(context, payload) {
        context.commit('selectedVisitClassificationForFilterationforPhysicianOrders', payload);
    },
    save_IsIV(context, payload) {
        context.commit('Save_IsIV', payload);
    },
    Save_LoadIVOrders(context, payload) {
        context.commit('Save_LoadIVOrders', payload);
    },
    save_isVisitViewFirstLoad(context, payload) {
        context.commit('isVisitViewFirstLoad', payload);

    }, save_advancedFilterResultsAddedItems(context, payload) {

        context.commit('advancedFilterResultsAddedItems', payload);
    },
    save_advancedFilterCriteria(context, payload) {

        context.commit('advancedFilterCriteria', payload);
    },


    save_PhysOrderAdvancedFilterCriteria(context, payload) {
        context.commit('PhysOrderAdvancedFilterCriteria', payload);
   
    },

    load_prescriptionTypeRadio(context, payload) {
        context.rootState.pharmacyState.pharmacyDataGlobal.isPatientCaptured = false;
        context.dispatch("clear_visitView");
        context.commit('save_prescriptionTypeRadio', payload);
    },
    load_DispenseTypeRadio(context, payload) {
        
        context.commit('save_DispenseTypeRadio', payload);
    },

    // start filtration of phy-order Tab 
    load_formFiltered_phyOrder(context, payload) {
        context.commit('save_formFiltered_phyOrder', payload);
    },
    load_userListFiltered_phyOrder({ commit, state }) {
        let formFiltered_phyOrder = state.formFiltered_phyOrder;
        let itemsFiltered = state.userList_phyOrder.filter((element) => {
            return element['ProcedureUserName'].toLowerCase().match(formFiltered_phyOrder['searchByNameID'].toLowerCase()) &&
                element['currentVisit'] == formFiltered_phyOrder['currentVisit'] &&
                element['visitClassification'].toLowerCase().match(formFiltered_phyOrder['visitClassification'].toLowerCase());
        });
        commit('save_userListFiltered_phyOrder', itemsFiltered);
    },
    // End filtration of phy-order Tab 

    // start filtration of Dis-History Tab 
    load_formFiltered_DisHistory(context, payload) {
        context.commit('save_formFiltered_DisHistory', payload);
    },
    load_userListFiltered_DisHistory({ commit, state }) {
        let VisitClassificationID = [1],
            StartDateTime = "2018-12-08",
            EndDateTime = "2020-12-15",
            //   StartDateTime = state.formFiltered_DisHistory.searchStartDate,
            //  EndDateTime   = state.formFiltered_DisHistory.searchEndDate,
            filter = "IsArrived=false&VisitTypeID=null&$count=true&%24format=json&%24top=20&%24orderby=PatientDisplayName%2CPhysicianEnName";
        PatientDetailsServiceConst.FilterPatientDetails(StartDateTime, EndDateTime, VisitClassificationID, filter, result => {
            state.userListFiltered_DisHistory = result.data.value;
            commit('save_userListFiltered_phyOrder', state.userListFiltered_DisHistory);
        });
        //let formFiltered_DisHistory = state.formFiltered_DisHistory;
        //let itemsFiltered = state.userListFiltered_DisHistory.filter((element) => {
        //    return element['ProcedureUserName'].toLowerCase().match(formFiltered_DisHistory['searchByNameID'].toLowerCase()) &&
        //        element['currentVisit'] == formFiltered_DisHistory['currentVisit'] &&
        //        element['visitClassification'].toLowerCase().match(formFiltered_DisHistory['visitClassification'].toLowerCase());
        //});
        //commit('save_userListFiltered_phyOrder', itemsFiltered);
    },
    load_userListFiltered_DisHistoryStatic({ commit, state }) {
        let formFiltered_DisHistory = state.formFiltered_DisHistory;
        let itemsFiltered = state.userList_DisHistory.filter((element) => {
            return element['ProcedureUserName'].toLowerCase().match(formFiltered_DisHistory['searchByNameID'].toLowerCase()) &&
                element['currentVisit'] == formFiltered_DisHistory['currentVisit'] &&
                element['visitClassification'].toLowerCase().match(formFiltered_DisHistory['visitClassification'].toLowerCase());
        });
        commit('save_formFiltered_DisHistory', itemsFiltered);
    },
    // End filtration of Dis-History Tab 

    // start filtration of E-prescription Tab 
    load_formFiltered_Prescription(context, payload) {
        context.commit('save_formFiltered_Prescription', payload);
    },
    load_userListFiltered_Prescription({ commit, state }) {
        let formFiltered_Prescription = state.formFiltered_Prescription;
        let itemsFiltered = state.userList_Prescription.filter((element) => {
            return element['ProcedureUserName'].toLowerCase().match(formFiltered_Prescription['searchByNameID'].toLowerCase()) &&
                element['currentVisit'] == formFiltered_Prescription['currentVisit'] &&
                element['visitClassification'].toLowerCase().match(formFiltered_Prescription['visitClassification'].toLowerCase());
        });
        commit('save_userListFiltered_Prescription', itemsFiltered);
    },
    // End filtration of E-prescription Tab 



    //load_userListFiltered_DisHistory({ commit, state }) { }


    load_globalPatientListDs(context, payload) {
        context.commit('save_globalPatientListDs', payload);
    },
    async load_gridOnClickingPatient({ commit, state }, payload) {
      
        if (!payload.reloadGridOnly) {
            commit('isVisitSelected', false);
        }
        state.SelectedItems = [];
        commit('Reset_SelectedItems', state);
        commit('save_showLoader', true);

        commit('isVisitViewFirstLoad', false);
        commit('isShowGridAdvancedFilter', false);
        commit('isFilterButtoneClicked', false);

        commit('isPhysOrderAdvncedFilterClicked', false);

        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        var visitId = payload.ID;

        //-----------------------------------------------------------------------------------------PhysicianOrder

        if (state.activeTabFilteration == getFilterationTabsEnum().PhysicianOrder) {
            commit('save_showLoaderPhyPrder', true);
            let orderStatus = [];
            orderStatus.push(parseInt(getOrderLineStatusEnum().Ordered));
            orderStatus.push(parseInt(getOrderLineStatusEnum().InProgress));

            //request 1
            let Parameters = {};
            // if (storedPhysOrderSearchCriteria == null) {
            Parameters.VisitID = payload.ID;
            Parameters.ProductID = null;
            Parameters.DispensedTodate = null;
            Parameters.Orderlinefromdate = null;
            Parameters.OrderlineTodate = null;
            Parameters.PhysicianID = null;
            Parameters.OrderlineStatus = orderStatus;
            Parameters.IsHomeMedication = false;
            Parameters.CreationNeedID =  [getMedicationCreationNeedIdEnum().Alternative];
            Parameters.CreatedbyModule = [getCreatedByModuleForMedicationEnum().InternalPhysician, getCreatedByModuleForMedicationEnum().Pharmacy];



            let selectedVisitClassification = parseInt(payload.SelectedVisitClassification);
            let initParams = {
                VisitId: visitId,
            }

            //
            await visitService.InitPharmacistPrescriptionVisitView(initParams, (response) => {
                debugger
                if (response.data) {
                    let visitData = response.data;
                    visitData.visitId = visitId;
                    visitData.selectedVisitClassification = selectedVisitClassification;

                    commit('save_VisitDispenseHistory', visitData);

                    let patientObject = {
                        PatientID: visitData.PatientInfoSection.PatientID,
                        VisitID: visitData.visitId,
                        VisitClassificationID: selectedVisitClassification,
                        showPatientBanner: true,
                    }

                    commit('save_PatientInfo', patientObject)
                    commit('save_showLoader', false);

                }
            })
            commit('isVisitViewFirstLoad', true);

            commit('Save_retrieveMedicationOLParameters', Parameters);

            commit('isVisitSelected', true);





        }

        //-----------------------------------------------------------------------------------------Prescription

        if ((state.activeTabFilteration == getFilterationTabsEnum().Prescription && state.isCompeletedStep != true)) {
            debugger
            let selectedVisitClassification = parseInt(payload.SelectedVisitClassification);
            let initParams = {
                VisitId: visitId,
                VisitClassification: selectedVisitClassification,
                CreationNeedID: [getMedicationCreationNeedIdEnum().Approval],
                IsHomeMedication: true,
                CreatedbyModule: [getCreatedByModuleForMedicationEnum().InternalPhysician, getCreatedByModuleForMedicationEnum().Pharmacy]
            }

            //
            await visitService.InitPharmacistPrescriptionVisitView(initParams, (response) => {
                if (response.data) {
                    let visitData = response.data;
                    visitData.visitId = visitId;
                    visitData.selectedVisitClassification = selectedVisitClassification;

                    commit('save_VisitDispenseHistory', visitData);

                    let patientObject = {
                        PatientID: visitData.PatientInfoSection.PatientID,
                        VisitID: visitData.visitId,
                        VisitClassificationID: selectedVisitClassification,
                        showPatientBanner: true,
                        moduleID: getPharamcyAttachmentEnum().VM_Pharmacy
                    }
                    let sessionVisitID = sessionStorage.setItem('sessionVisitID', visitData.visitId)
                    console.log(sessionVisitID)

                    commit('save_PatientInfo', patientObject)
                    commit('save_showLoader', false);

                }
            }, () => {
                    commit('save_showLoader', false);
            });

            //Medication Data
            let orderStatus = [];
            orderStatus.push(parseInt(getOrderLineStatusEnum().Ordered));
            orderStatus.push(parseInt(getOrderLineStatusEnum().InProgress));
            orderStatus.push(parseInt(getOrderLineStatusEnum().Complete));

            let Parameters = {};
            Parameters.VisitID = visitId;
            Parameters.ProductID = null;
            Parameters.DispensedTodate = null;
            Parameters.Orderlinefromdate = null;
            Parameters.OrderlineTodate = null;
            Parameters.PhysicianID = null;
            Parameters.OrderlineStatus = orderStatus;
            Parameters.IsHomeMedication = true;
            Parameters.CreationNeedID = [getMedicationCreationNeedIdEnum().Approval, getMedicationCreationNeedIdEnum().Alternative];
            Parameters.CreatedbyModule = [getCreatedByModuleForMedicationEnum().InternalPhysician, getCreatedByModuleForMedicationEnum().Pharmacy];


            commit('Save_retrieveMedicationOLParameters', Parameters);
        }

        //-----------------------------------------------------------------------------------------DispenseHistory

        if (state.activeTabFilteration == getFilterationTabsEnum().DispenseHistory || state.activeTabFilteration == getFilterationTabsEnum().PhysicianOrder
            || (state.activeTabFilteration == getFilterationTabsEnum().Prescription && state.isCompeletedStep == true)) { //dispensing history
            debugger
           
            let inPatientClassification = parseInt(getVisitClassificationEnum().InPatient)
            let selectedVisitClassification = parseInt(payload.SelectedVisitClassification);
            let storedSearchCriteria = state.advancedFilterCriteria;
            let searchCriteriaToUse = {};
            let useDefaultFilterData = storedSearchCriteria.VisitId != parseInt(visitId);

            if (state.activeTabFilteration == getFilterationTabsEnum().DispenseHistory) {
                storedSearchCriteria.isByOrderMode = false;
                storedSearchCriteria.DoneServicesIds = [];
            }
            let DoneServicesIds = [];
            if (state.isByOrderMode && state.activeTabFilteration == getFilterationTabsEnum().Prescription && state.isCompeletedStep == true) {
                DoneServicesIds = state.DoneServicesIdsForcompleteStep;
            }

            let defaultSearchCriteria = dispensedHistoryCommon.PrepareDefaultVisitServiceSearchCriteria(visitId, true, DoneServicesIds, state.isByOrderMode);


            if (state.isByOrderMode || useDefaultFilterData) {
                searchCriteriaToUse = defaultSearchCriteria;
                commit('isVisitViewFirstLoad', true);
            }
            else {
                searchCriteriaToUse = storedSearchCriteria;
            }

            if (state.IsIV != true || (state.IsIV && state.isIvGoToDispenseHistory)) {
                await visitService.InitPharmaciestVisitViewByCassification(searchCriteriaToUse, (response) => {
                    if (response.data) {
                        let visitData = response.data;
                        commit('save_VisitNoteDS', visitData.NoteList);
                        visitData.visitId = visitId;
                        visitData.selectedVisitClassification = parseInt(selectedVisitClassification);
                        //Get Clinical Service Data
                        let queryString = dispensedHistoryCommon.MapVisitServiceSearchCriteria(searchCriteriaToUse);
                        let servicesInitUrl = visitService.SearchVisitServiceDataByClassification + queryString;
                        let sortTxt = visitData.selectedVisitClassification == inPatientClassification ? "asc" : "desc"
                        visitData.ClinicalServicesDataSource = dispensedHistoryCommon.BindODataGrid(servicesInitUrl, "ID",
                            {
                                ID: { type: "number" },
                            },
                            "ClaimDate", sortTxt
                        );

                        //get canceled services
                        let defaultCanceledSericesSerachObj = dispensedHistoryCommon.PrepareDefaultCanceledVisitServiceSearchCriteria(visitId, true);
                        let canceledQueryString = dispensedHistoryCommon.MapVisitServiceSearchCriteria(defaultCanceledSericesSerachObj);
                        let CanceledServicesInitUrl = visitService.SearchVisitServiceDataByClassification + canceledQueryString;

                        visitData.CancelledServicesDataSource = dispensedHistoryCommon.BindODataGrid(CanceledServicesInitUrl,
                            "ID",
                            {
                                ID: { type: "number" },
                            },
                            "CancelledDateTime", sortTxt
                        );
                        //summary footer
                        visitData.SummaryFooter = response.data.SummaryFooter;
                        //get total payment
                        let totalPaymentsUrl = visitService.GetPaymentTransactions(visitId);
                        visitData.TotalPaymentsDataSource = dispensedHistoryCommon.BindODataGrid(totalPaymentsUrl,
                            "ID",
                            {
                                ID: { type: "number" },
                            },
                        );

                        if (localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'ar') {
                            visitData.VisitInfoSection.CreateTime = visitData.VisitInfoSection.CreateTime.toUpperCase().replace("PM", "م").replace("AM", "ص");
                        }

                        commit('advancedFilterResultsAddedItems', visitData.ClinicalServicesDataSource);
                        commit('save_VisitDispenseHistory', visitData);


                        commit('advancedFilterCriteria', searchCriteriaToUse);

                        console.log("outpatientttt", visitData.ClinicalServicesDataSource)

                
                        let patientObject = {
                            PatientID: visitData.PatientInfoSection.PatientID,
                            VisitID: visitData.visitId,
                            VisitClassificationID: selectedVisitClassification,
                            showPatientBanner: true,
                            moduleID: getPharamcyAttachmentEnum().VM_Pharmacy
                        }
                        let sessionVisitID = sessionStorage.setItem('sessionVisitID',visitData.visitId)
                        console.log("sessionVisitID",sessionVisitID)
                        
                        console.log("patientObject", patientObject)
                        commit('save_PatientInfo', patientObject)
                        commit('save_showLoader', false);

                    }
                }, () => {
                    commit('save_showLoader', false);
                    commit('save_VisitNoteDS', []);
                    commit('save_PatientInfo', {})
                    commit('advancedFilterResultsAddedItems', []);
                    commit('save_VisitDispenseHistory', {});
                    commit('advancedFilterCriteria', {});
                    commit('save_isIvGoToDispenseHistory', false);
                });
            }
            else {
                commit("Save_LoadIVOrders", true);
            }

        }




        if (state.activeTabFilteration != 1) {

            commit('isVisitSelected', true);
        }

        EventBus.$emit('CancelVisitInitIcon', "");// used in pharmacy-management
    },
    goToDespensedHistory({ state }) {
        state.activeTabFilteration = 2;
        //let saveResponse = {};
        //commit('save_VisitDispenseHistory', saveResponse);
    },
    goToInfo({ state }) {
        console.log(state)
    },
    //showloader({ state }) {
    //    state.
    //}


    //},


    Save_isCreditCashRefund(context, payload) {
        context.commit('Save_isCreditCashRefund', payload);
    },

    save_isClinicalServiceTabSelected(context, payload) {
        context.commit('save_isClinicalServiceTabSelected', payload);
    },


    save_isReturnByrecieptSelected(context, payload) {
        context.commit('save_isReturnByrecieptSelected', payload);
    },

    save_VisitDispenseHistory(context, payload) {
        context.commit('save_VisitDispenseHistory', payload);
    },
    save_PatientInfo(context, payload) {
        context.commit('save_PatientInfo', payload);
    },
};

export default {
    mutations,
    actions,
    state,
    getters
};
